import React, { useState, useEffect } from "react";
import FieldDropdownV2 from "src/components/FormComponents/FieldDropdownV2"
import FieldV2 from "src/components/FormComponents/FieldV2"
import * as S from "./ReceivementWeightForm.styles"
import Suffix from "../Suffix"
import { formatNumber } from "src/utils/formatNumber"
import InformationField from "../InformationField"

export default ({
  tiposAvaria,
  watch,
  control,
  handleOnKeyDown,
  setValue,
  resetField,
  dueDateTypeConfig,
  dueDateDamage,
  labelForDueDate
}) => {
  const tipoAvaria = watch('tipoAvarias')
  const [damageReadOnly, setDamageReadOnly] = useState(true)

  useEffect(() => {
    if (tipoAvaria === 'NENHUM') {
      setDamageReadOnly(true)
      resetField('quantidadeAvarias')
    } else if (tipoAvaria === 'DANO') {
      setDamageReadOnly(false)
      setValue('quantidadeAvarias', '')
    } else if (tipoAvaria === 'VENCIDO') {
      setDamageReadOnly(true)
    }
  }, [tipoAvaria])

  return (
    <>
      <Suffix suffix={'Kg'}>
        <S.Field
          as={FieldV2}
          control={control}
          type="text"
          labelText="Pesagem em quilos"
          name="weight"
          onInput={formatNumber}
          placeholder="0,000"
          onKeyDown={(e) => handleOnKeyDown(e, dueDateTypeConfig === 'INDETERMINATE' ? "tipoAvarias" : "validade")}
        />
      </Suffix>
      {dueDateTypeConfig === 'INDETERMINATE' ? (
        <InformationField
          title='Validade'
          info='Automática'
          tooltipInfoMessage='Validade definida pelo sistema'
          testId='automatic-due-date-test-id'
        />
      ) : dueDateTypeConfig === 'LONG_DURATION' ? (
        <S.Field
          as={FieldV2}
          control={control}
          onKeyDown={(e) => handleOnKeyDown(e, dueDateDamage ? "quantidadeAvarias" : "tipoAvarias")}
          type='month'
          labelText={labelForDueDate}
          name="validade"
          inputTextColor={dueDateDamage ? 'red' : 'black'}
          width={'13rem !important'}
        />
      ) : (
        <S.Field
          as={FieldV2}
          control={control}
          onKeyDown={(e) => handleOnKeyDown(e, dueDateDamage ? "quantidadeAvarias" : "tipoAvarias")}
          type='date'
          labelText={labelForDueDate}
          name="validade"
          inputTextColor={dueDateDamage ? 'red' : 'black'}
        />
      )}
      {dueDateDamage ? (
        <InformationField
          title='Tipo Avaria'
          info='VENCIDO'
          tooltipInfoMessage='Lote definido automaticamente como vencido'
          testId='automatic-damage-type-test-id'
        />
      ) : (
        <S.Field
          as={FieldDropdownV2}
          control={control}
          onKeyDown={(e) => handleOnKeyDown(e, "quantidadeAvarias")}
          labelText='Tipo avaria'
          type="text"
          name="tipoAvarias"
          options={tiposAvaria.map((v) => ({ value: v, label: v }))}
        />
      )}
      <Suffix suffix={'Kg'}>
        <S.Field
          as={FieldV2}
          control={control}
          type="text"
          labelText="Qtd. avarias"
          name="quantidadeAvarias"
          onInput={formatNumber}
          placeholder="0,000"
          readOnly={damageReadOnly}
        />
      </Suffix>
      <Suffix suffix={'Kg'}>
        <S.Field
          as={FieldV2}
          control={control}
          type="text"
          name='qtdUtilKg'
          labelText='Qtd. Útil Total'
          value={watch('qtdUtilKg')}
          // onInput={formatNumber}
          readOnly
        />
      </Suffix>
    </>
  );
};
